import {allFamilies, Family, sizeOfFamily} from "./spectra";
import React from "react";

export interface FamilySelectorProps {
    onSelect: (f: Family) => void,
    selected?: Family,
}

export function FamilySelector(props: FamilySelectorProps) {
    let options: JSX.Element[] = [];
    if (props.selected === undefined) {
        options.push(<option key="">Select a wave family</option>);
    }
    for (let f of allFamilies) {
        let label;
        const size = sizeOfFamily(f);
        if (size !== 1) {
            label = `${f} (${size})`;
        } else {
            label = f;
        }
        options.push(<option
            key={f}
            value={f}>
            {label}
        </option>);
    }
    return (<select
        className="selector"
        onChange={(ev) => props.onSelect(ev.target.value as Family)}
        value={props.selected}>
        {options}
    </select>);
}